import {DomainStore} from 'shared/store';
import {endpoints, types} from 'shared/core';
import Employee from 'stores/employees/Employee';
import _ from 'lodash';

class ManagerDataSource {
  store = new DomainStore();

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEES.MANAGERS
    ]);

    return this.store.getAllOrdered(types.EMPLOYEE, Employee);
  }
}

export default ManagerDataSource;
